import styled from "styled-components";
import CompHeader from "../component/header";
import CompFooter from "../component/footer";
import CompTaskManageClass from "../component/taskManageClass";

const Container = styled.div`
  height: 95vh;
  width: 80vw;
  margin: 2.5vh 10vw 2.5vh 10vw;
  padding: 0;
  background-color: whitesmoke;
  border-radius: 20px 20px 0 0;
`;
const Header = styled.header`
  height: 5%;
  width: 100%;
`;
const Footer = styled.footer`
  margin-top: 10%;
  height: 10%;
  width: 100%;
`;
const Main = styled.main`
  height: 89%;
  width: 100%;
`;
function PageManageClass(props) {
  return (
    <Container>
      <Header>
        <CompHeader />
      </Header>
      <Main>
        <CompTaskManageClass />
      </Main>
      <Footer>
        <CompFooter />
      </Footer>
    </Container>
  );
}

export default PageManageClass;
